/* eslint-disable @typescript-eslint/camelcase */
export const InitialValues = {
  primary_contrast_text_color: '#5b52c4',
  primary_dark_color: '#efcd33',
  primary_main_color: '#efcd33',
  primary_light_color: '#efcd33',
  secondary_contrast_text_color: '#357FFA',
  secondary_dark_color: '#357FFA',
  secondary_main_color: '#357FFA',
  secondary_light_color: '#357FFA',
  primary_color: '#efcd33',
  secondary_color: '#357FFA',
  background_color: '#0064af',
  text_hover_color: '#5b52c4',
  image_login_background_color: '#F7B528',
  logo_background_color: '#fafafa',
  header_login_font_size: '45px',
  description_login_font_size: '16px',
  header_login_text_pt_br: 'Seja bem-vindo!',
  header_login_text_en: 'Welcome!',
  header_login_text_es: '¡Bienvenido!',
  description_login_text_pt_br:
    'Faça seu login para iniciar o acesso ao seu sistema de forma online, com dados criptografados e armazenados em ambientes seguros!',
  description_login_text_en:
    'Log in to access your system online, with encrypted data stored in secure environments!',
  description_login_text_es:
    'Inicie sesión para acceder a su sistema en línea, con datos encriptados y almacenados en entornos seguros!',

  header_mfa_font_size: '45px',
  header_mfa_text_pt_br: 'Seja bem-vindo!',
  header_mfa_text_en: 'Welcome!',
  header_mfa_text_es: '¡Bienvenido!',
  description_mfa_font_size: '16px',
  description_mfa_text_pt_br:
    'Com a plataforma Autosky, você leva seu software monolítico para a nuvem, sem mexer em nenhuma linha de código, com banco de dados e usuários configurados em poucas horas',
  description_mfa_text_en:
    'With the Autosky platform, you can move your monolithic software to the cloud without modifying a single line of code, with databases and users set up in just a few hours.',
  description_mfa_text_es:
    'Con la plataforma Autosky, puede llevar su software monolítico a la nube sin modificar ni una sola línea de código, con bases de datos y usuarios configurados en pocas horas.',
  subdomain: '',
  title: 'Autosky | Portal de Login',
  message_text_color: '#E1AF44',
  background_image: 'images/background.png',
  logo_image: 'images/Auto.Sky_PNG_Colorido.png',
  maintenance_image: 'images/newMaintenance.png',
  messages_image: 'images/newYellow.png',
  favicon_image: 'favicon_yellow.png',
  default_banner_option: 0,
  app_color: '#000A62',
  details_login_color: '#d9d9d9',
};
